import React, { useState } from 'react';
import emailjs from 'emailjs-com';

// Reusable Input component
const Input = ({ label, id, name, type = 'text', value, onChange, required = false }) => (
  <div className="mb-6">
    <label htmlFor={id} className="block text-lg font-medium text-gray-700">{label}</label>
    <input
      type={type}
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      className="w-full rounded border border-gray-300 bg-white p-3 text-gray-800 focus:ring-blue-500 focus:border-blue-500"
    />
  </div>
);

// Reusable RadioButton component
const RadioButton = ({ label, name, value, checked, onChange }) => (
  <label className="flex items-center">
    <input
      type="radio"
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
      className="mr-2"
    />
    {label}
  </label>
);

// Contact Form Component
const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    emailType: 'individual',
    companyName: '',
    message: ''
  });

  const [notification, setNotification] = useState('');

  // Handles input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handles form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    const { email, firstName, lastName, emailType, companyName, message } = formData;
    
    const templateParams = {
      email,
      firstName,
      lastName,
      emailType,
      companyName,
      message
    };

    // Use EmailJS to send the email
    emailjs.send('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', templateParams, 'YOUR_USER_ID')
      .then(() => {
        setNotification('Message sent successfully!');
        setTimeout(() => setNotification(''), 3000); // Clear notification after 3 seconds
      })
      .catch((error) => {
        console.error('Failed to send email:', error);
        setNotification('Failed to send message. Please try again later.');
      });
  };

  return (
    <div className="p-6 bg-gray-100 shadow-lg rounded-lg">
      <form onSubmit={handleSubmit}>
        <Input label="First Name" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} required />
        <Input label="Last Name" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} required />

        {/* Email Type Radio Buttons */}
        <div className="mb-6">
          <label className="block text-lg font-medium text-gray-700">Email Type</label>
          <div className="flex items-center space-x-4">
            <RadioButton label="Individual" name="emailType" value="individual" checked={formData.emailType === 'individual'} onChange={handleChange} />
            <RadioButton label="Company" name="emailType" value="company" checked={formData.emailType === 'company'} onChange={handleChange} />
          </div>
        </div>

        <Input label="Email" id="email" name="email" type="email" value={formData.email} onChange={handleChange} required />

        {/* Conditionally rendering Company Name input */}
        {formData.emailType === 'company' && (
          <Input label="Company Name" id="companyName" name="companyName" value={formData.companyName} onChange={handleChange} />
        )}

        {/* Message Textarea */}
        <div className="mb-6">
          <label htmlFor="message" className="block text-lg font-medium text-gray-700">Message</label>
          <textarea
            id="message"
            name="message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
            className="w-full rounded border border-gray-300 bg-white p-3 text-gray-800 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full py-3 rounded bg-blue-900 text-[#C5B358] text-lg transition-transform duration-300 hover:scale-105 hover:bg-[#013751]"
        >
          Send Message
        </button>
      </form>

      {/* Notification */}
      {notification && (
        <div className="mt-4 p-4 text-gray-900 bg-green-300 rounded font-bold text-center">
          {notification}
        </div>
      )}
    </div>
  );
};

export default ContactForm;
